export const LANGUAGES = {
  FR_FR: 'fr-FR',
  EN_UK: 'en-UK',
  ES_ES: 'es-ES',
};
